<script>
import { PhxIcon } from '@phx-styleguides/jlc';
import moment from '@phoenix/moment';

export default {
  components: { PhxIcon },

  props: {
    openingExceptions: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hoursExceptions() {
      const exceptions = this.openingExceptions?.hoursExceptions;

      if (!exceptions) {
        return [];
      }

      return exceptions.filter((exception) => this.isTodayOrFuture(exception.date));
    },
  },

  mounted() {
    if (this.$refs.collapseContent) {
      new Toolkit.Collapse(this.$refs.collapseContent);
    }
  },

  methods: {
    isTodayOrFuture(startDate) {
      const dateNow = moment().startOf('day');
      const target = moment(startDate).startOf('day');
      return target.isSameOrAfter(dateNow);
    },
  },
};
</script>

<template>
  <ul
    v-if="hoursExceptions.length > 0"
    id="opening-hours-exceptions"
    class="accordion menu menu--border-full-width menu--small"
  >
    <li class="menu__item accordion__item">
      <button
        class="accordion__title menu__entry menu__link menu__toggle accordion__toggle"
        data-toggle="collapse"
        data-target="#opening-hours-exceptions-content"
        aria-expanded="false"
      >
        {{ $t('Store.exceptionalClosing') }}
        <phx-icon icon="chevron-down-10" class="icon--10" />
      </button>

      <div id="opening-hours-exceptions-content" ref="collapseContent" class="accordion__content collapse">
        <div class="boutique-details-schedule py-sm">
          <template v-for="exception in hoursExceptions" :key="exception.date">
            <div class="boutique-details-schedule__day">{{ exception.dateFormatted }}</div>

            <div class="boutique-details-schedule__hours">
              <span v-if="exception.isClosed">{{ $t('store.closed') }} </span>

              <template v-else-if="exception.openIntervals && exception.openIntervals.length">
                <span v-for="(interval, index) in exception.openIntervals" :key="index">
                  {{ `${interval.start} - ${interval.end}` }}
                </span>
              </template>

              <span v-else>{{ $t('store.openStatus') }}</span>
            </div>
          </template>
        </div>
      </div>
    </li>
  </ul>
</template>
